import { createAsyncThunk } from "@reduxjs/toolkit";
import mineCraftApi from 'src/api/mineCraftApi';

// Account-level crafty-servers surface — quota, cross-server player
// leaderboard and the webhook delivery journal. Unlike serversActions,
// nothing here is scoped to a Server row (crafty holds one platform
// API key), so these live apart. Raw payloads, no Redux slice.

export const fetchHostingAccount = createAsyncThunk(
  'hosting/fetchHostingAccount',
  async (_: void, { rejectWithValue }) => {
    try {
      const response = await mineCraftApi.get('/onesky/crafty_servers/me');
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || error);
    }
  }
);

export const fetchHostingLeaderboard = createAsyncThunk(
  'hosting/fetchHostingLeaderboard',
  async ({ limit }: { limit?: number }, { rejectWithValue }) => {
    try {
      const response = await mineCraftApi.get('/onesky/crafty_servers/leaderboard', { params: { limit } });
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || error);
    }
  }
);

export const fetchHostingWebhookDeliveries = createAsyncThunk(
  'hosting/fetchHostingWebhookDeliveries',
  async (
    { limit, offset, event, success }: { limit?: number, offset?: number, event?: string, success?: boolean },
    { rejectWithValue }
  ) => {
    try {
      const response = await mineCraftApi.get('/onesky/crafty_servers/webhook_deliveries', {
        params: { limit, offset, event, success }
      });
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || error);
    }
  }
);

export const retryHostingWebhookDelivery = createAsyncThunk(
  'hosting/retryHostingWebhookDelivery',
  async ({ deliveryId }: { deliveryId: string }, { rejectWithValue }) => {
    try {
      const response = await mineCraftApi.post(
        `/onesky/crafty_servers/webhook_deliveries/${encodeURIComponent(deliveryId)}/retry`
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || error);
    }
  }
);
